import { useFetcher, useParams } from 'react-router';
import { useEffect } from 'react';
import { protectedResourceLoader } from '~/shell/utils/authUtil.server';
import { fetchFavoriteTemplates } from '~/features/templates/templates.server';
import { PgArea, TgArea } from '~/common/types/area';
import { getLatestTemplateIdFromContext } from '~/shell/globalContext.ts';
import { WebTemplateTypes } from '../../types/webTemplateType';
import type { Language } from '~/common/types/language';
import { fallbackLng } from '~/i18nConfig';

export const loader = protectedResourceLoader(async ({ area, api }) => {
  try {
    const templateType = area === TgArea ? WebTemplateTypes.BGH : WebTemplateTypes.AGH;
    const response = await fetchFavoriteTemplates(api, templateType);
    const latestTemplateId = await getLatestTemplateIdFromContext();
    return {
      latestTemplateId,
      templates: response,
      ok: true
    };
  } catch {
    return { ok: false };
  }
});

export function useFavoriteTemplates(isTgArea: boolean) {
  const { load, data, state } = useFetcher<typeof loader>();
  const { lang: langParam } = useParams() as { lang?: Language };
  const lang = langParam ?? fallbackLng;

  useEffect(() => {
    load(`/${lang}/${isTgArea ? TgArea : PgArea}/resources/templates/favorites`);
  }, [lang, isTgArea, load]);

  return {
    templates: data?.templates,
    isLoading: state !== 'idle',
    latestTemplateId: data?.latestTemplateId,
    ok: data?.ok
  };
}
